module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }